import { DURATION } from '@Bill/constants'
import { currencyUnitMap } from '@/constants/currency'
import i18n from '@/locales'

function getRateText ({ row, rate, step, unit, showStep = false, currency = 'CNY' }) {
  const { cycle } = row
  const rateNum = Number(rate)
  const newRate = rateNum.toFixed(6)
  let sign = ''
  if (currencyUnitMap[currency]) {
    sign = currencyUnitMap[currency].sign
  }
  if (showStep) {
    return i18n.t('bill.rate.each') + step + unit + ' ' + i18n.t('bill.text_161', [sign, newRate, DURATION[cycle]])
  }
  return i18n.t('bill.text_161', [sign, newRate, DURATION[cycle]])
}

export const getPriceStepAndUnit = (price_unit = '') => {
  let step = 1
  let unit = price_unit
  const steps = price_unit.match(/\d+/g)
  if (steps) {
    step = Number(steps[0])
    unit = price_unit.replace(steps[0], '')
  }
  return { step, unit }
}

export const getRateRulesColumn = () => {
  return {
    field: 'rate',
    title: i18n.t('bill.rate.title.rate'),
    width: 80,
    // type: 'expand',
    slots: {
      default: ({ row }, h) => {
        if (row.no_bill) return i18n.t('bill.no_bill')
        const data = []
        const { step_rates = {}, price_unit, price_type, usage_type } = row
        const { step: initStep, unit } = getPriceStepAndUnit(price_unit)
        const keys = Object.keys(step_rates)
        let unitI18n = unit === 'instance' ? i18n.t('rate.price_unit.general_instance') : unit
        if (usage_type === 'cpu' && unit === 'instance') {
          unitI18n = i18n.t('rate.price_unit.cpu_instance')
        }
        if (usage_type === 'requests') {
          unitI18n = i18n.t('rate.price_unit.requests')
        }
        keys.map(key => {
          let rate = ''
          if (price_type === 'amount' || price_type === 'amount_range') {
            rate = getRateText({ row, rate: step_rates[key], step: initStep, unit: unitI18n, showStep: true, currency: row.currency })
          } else {
            rate = getRateText({ row, rate: step_rates[key], currency: row.currency })
          }
          if (key === '_base_') {
            data.unshift({ step: i18n.t('bill.rate.base_rate'), rate })
          } else {
            data.push({ step: `${i18n.t('bill.rate.gt')} ${key}${unitI18n}`, rate })
          }
        })
        const ret = []
        data.map((item, index) => {
          ret.push(<div>{(index === 0 && price_type === 'amount') ? item.rate : `${item.step}: ${item.rate}`}</div>)
        })
        return ret
      },
      // content: ({ row }, h) => {
      //   const columns = [
      //     {
      //       title: i18n.t('bill.rate.step_line'),
      //       field: 'step',
      //     },
      //     {
      //       title: i18n.t('bill.rate.billing_rules'),
      //       field: 'rate',
      //     },
      //   ]
      //   const data = []
      //   const { step_rates = {}, unit, price_unit, price_type } = row
      //   const initStep = Number((price_unit || '').replace(unit || '', '') || '1')
      //   const keys = Object.keys(step_rates)
      //   const unitI18n = unit === 'instance' ? '实例' : unit
      //   keys.map(key => {
      //     let rate = ''
      //     if (price_type === 'amount' || price_type === 'amount_range') {
      //       rate = getRateText({ row, rate: step_rates[key], step: initStep, unit: unitI18n, showStep: true })
      //     } else {
      //       rate = getRateText({ row, rate: step_rates[key] })
      //     }
      //     if (key === '_base_') {
      //       data.unshift({ step: i18n.t('bill.rate.base_rate'), rate })
      //     } else {
      //       data.push({ step: `${i18n.t('bill.rate.gt')} ${key}${unitI18n}`, rate })
      //     }
      //   })
      //   return <vxe-grid size="mini" border columns={columns} data={data} />
      // },
    },
    formatter: ({ row }) => {
      if (row.no_bill) return i18n.t('bill.no_bill')
      const data = []
      const { step_rates = {}, price_unit, price_type, usage_type } = row
      const { step: initStep, unit } = getPriceStepAndUnit(price_unit)
      const keys = Object.keys(step_rates)
      let unitI18n = unit === 'instance' ? i18n.t('common_92') : unit
      if (usage_type === 'cpu' && unit === 'instance') {
        unitI18n = i18n.t('common_60')
      }
      keys.map(key => {
        let rate = ''
        if (price_type === 'amount' || price_type === 'amount_range') {
          rate = getRateText({ row, rate: step_rates[key], step: initStep, unit: unitI18n, showStep: true })
        } else {
          rate = getRateText({ row, rate: step_rates[key] })
        }
        if (key === '_base_') {
          data.unshift({ step: i18n.t('bill.rate.base_rate'), rate })
        } else {
          data.push({ step: `${i18n.t('bill.rate.gt')} ${key}${unitI18n}`, rate })
        }
      })
      return JSON.stringify(data)
    },
  }
}
